import './person-card.scss';
import './person-card.html.twig';
